import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
  ViewTableModule,
  SharedModule,
  DaterangepickerModule,
  AutocompleteModule,
  ComboModule,
  InputModule,
} from 'beyond-util';

import { IzvestajZaSokojComponent } from './izvestaj-za-sokoj.component';
import { ReportHeaderModule } from '../../../components/report-header/report-header.module';

@NgModule({
  declarations: [IzvestajZaSokojComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    ViewTableModule,
    ReportHeaderModule,
    DaterangepickerModule,
    AutocompleteModule,
    ComboModule,
    InputModule,
    SharedModule,
    NgxSpinnerModule,
  ],
  exports: [IzvestajZaSokojComponent],
  entryComponents: [IzvestajZaSokojComponent],
})
export class IzvestajZaSokojModule {}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/izvestaj-za-sokoj/izvestaj-za-sokoj.module.ts